
import { rzButton } from '@razlet/ui';

export default {
  name: 'bids-request',
  layout: 'index',
  components: {
    rzButton,
  },
  data() {
    return {
      isReturnWindowOpened: false,
      returnWindowType: null,
    };
  },
  methods: {
    findTicket() {
      const event = new CustomEvent('open-return', {});
      window.dispatchEvent(event);
    },
  },
};
